import { render, staticRenderFns } from "./PlanSection.vue?vue&type=template&id=304bfb8c&scoped=true"
import script from "./PlanSection.vue?vue&type=script&lang=js"
export * from "./PlanSection.vue?vue&type=script&lang=js"
import style0 from "./PlanSection.vue?vue&type=style&index=0&id=304bfb8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304bfb8c",
  null
  
)

export default component.exports